// extracted by mini-css-extract-plugin
export default {"cover":"Cover_cover__wpPzG","aboutVideo":"Cover_aboutVideo__yI2aM"};